<b3-modal
  #approveModal
  [open]="open"
  overlay
  size="md"
  (b3-close)="onModalDismiss()">
  <b3-modal-header
    heading="Aprovar registro de crédito?"
    aria-level="2"
    icon="check_circle"
    icon-tone="success"
    close-aria-label="Fechar">
  </b3-modal-header>

  <b3-modal-body>
    <p class="operation-confirmation-approve-modal__text">
      Ao aprovar o registro, o detentor poderá seguir com o registro na B3.
    </p>
  </b3-modal-body>

  <b3-modal-footer>
    <div class="operation-confirmation-approve-modal__footer">
      <b3-button
        type="button"
        variant="outlined"
        tone="default"
        (b3-click)="onCancel()">
        <b3-icon name="cancel" size="md"></b3-icon>
        Cancelar
      </b3-button>
      <b3-button
        type="button"
        variant="filled"
        tone="default"
        (b3-click)="onConfirm()">
        <b3-icon name="check_circle" size="md" tone="on-brand"></b3-icon>
        Confirmar
      </b3-button>
    </div>
  </b3-modal-footer>
</b3-modal>
